@if (vendorId()) {
<app-vendor-form-wrapper
  data-testid="vendor-edit-form-wrapper"
  #formWrapper
  [mode]="'edit'"
  [vendorId]="vendorId()!"
></app-vendor-form-wrapper>
}

